export const aciHistorial = {
    iconName: 'historial',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M6.4 12.666v-.5a7.1 7.1 0 117.1 7.1.6.6 0 110-1.2 5.902 5.902 0 004.172-10.071A5.9 5.9 0 007.6 12.166v.5a.6.6 0 11-1.2 0z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M8.576 10.24a.599.599 0 11.848.848l-2 2a.599.599 0 01-.848 0l-2-2-.077-.093a.6.6 0 01.831-.831l.094.077L7 11.817l1.576-1.576zM12.4 8.165a.6.6 0 111.2 0v3.9h2.9l.121.012a.6.6 0 010 1.175l-.12.012H13a.6.6 0 01-.6-.6v-4.5z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
